import { createFeatureSelector, createSelector } from '@ngrx/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Country } from '../models';

export interface CountriesState {
  pending: boolean;
  countries: Country[];
}

const initialState: CountriesState = {
  pending: false,
  countries: []
};

export const countriesSlice = createSlice({
  name: 'countries',
  initialState,
  reducers: {
    loadCountries: (state) => {
      state.pending = true;
    },
    loadCountriesFulfilled: (state: CountriesState, action: PayloadAction<Country[]>) => {
      state.countries = action.payload;
      state.pending = false;
    },
    loadCountriesRejected: (state: CountriesState) => {
      state.countries = [];
      state.pending = false;
    }
  }
});

const {
  name,
  reducer,
  actions: { loadCountries, loadCountriesFulfilled, loadCountriesRejected }
} = countriesSlice;

export default countriesSlice.reducer;
export { name, loadCountries, loadCountriesFulfilled, loadCountriesRejected };

export const selectFeature = createFeatureSelector<ReturnType<typeof reducer>>(name);

export const selectCountries = createSelector(
  selectFeature,
  (state: CountriesState) => state.countries
);
